import { clsx } from 'clsx'

import { useFirstRenderContext } from '../../common/ssr/FirstRenderProvider.js'
import { ReactPlayer } from '../../utils/react-player.js'

type AvRendererProps = {
  url: string
  isAudio: boolean
  isActive: boolean
}
export const AudioVidePreviewRenderer = (props: AvRendererProps) => {
  const { url, isAudio, isActive } = props
  const { isFirstRender } = useFirstRenderContext()
  return (
    <div className="min-h-0 max-h-full grow basis-full flex flex-col justify-center items-center">
      <div
        className={clsx(
          'w-full sm:w-[initial] sm:min-w-[340px] max-h-full flex items-center',
          /**
           * ReactPlayer does not allow configuring the inner audio
           * element height, as in setting height to 'revert' on the wrapper
           * will still make the audio/video element to be of size 100%
           * and none of the option will force the element assume its natural height.
           * That's why the following className is added to the container with important specificity.
           */
          isAudio ? '[&_audio]:!h-[revert] px-3 sm:px-0' : 'aspect-auto',
        )}
      >
        {!isFirstRender && (
          <ReactPlayer
            controls
            playing={isActive}
            config={{ file: { forceAudio: isAudio } }}
            muted={!isAudio}
            width="100%"
            height={isAudio ? 'revert' : '100%'}
            style={{
              display: 'flex',
              width: '100%',
            }}
            url={url}
          />
        )}
      </div>
    </div>
  )
}
